"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToolTip = require("./ToolTip.styled");
var _useStudioLiteContext = require("../../hooks/useStudioLiteContext/useStudioLiteContext");
var _excluded = ["targetElement", "message", "placement", "displayTooltip", "mode", "noPointerEvent", "fade"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// eslint-disable-next-line react/display-name
var ToolTip = exports.ToolTip = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var targetElement = _ref.targetElement,
    message = _ref.message,
    placement = _ref.placement,
    displayTooltip = _ref.displayTooltip,
    mode = _ref.mode,
    noPointerEvent = _ref.noPointerEvent,
    fade = _ref.fade,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isDirectorLite = (0, _useStudioLiteContext.useStudioLiteContext)();
  var elementId = "tooltip_".concat(targetElement);
  var isLight = mode === 'light' && !isDirectorLite;
  var selectedToolTipStyle = isLight ? _ToolTip.ToolTipStyle : _ToolTip.ToolTipStyleDark;
  if (!displayTooltip) return null;
  return /*#__PURE__*/_react["default"].createElement(_ToolTip.StyledToolTip, (0, _extends2["default"])({
    id: elementId,
    placement: placement,
    style: selectedToolTipStyle,
    target: targetElement,
    "data-testid": elementId,
    isLight: isLight,
    $noPointerEvent: noPointerEvent,
    fade: fade
  }, rest), message);
});
ToolTip.propTypes = {
  fade: _propTypes.bool,
  mode: _propTypes.string,
  placement: _propTypes.string,
  displayTooltip: _propTypes.bool,
  noPointerEvent: _propTypes.bool,
  message: _propTypes.string.isRequired,
  targetElement: _propTypes.string.isRequired
};
ToolTip.defaultProps = {
  placement: 'bottom',
  displayTooltip: true,
  mode: 'light',
  noPointerEvent: false
};